import {Search} from '@mui/icons-material';
import {Typography} from '@mui/material';
import {makeStyles} from '@mui/styles';
import React from 'react';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
  },

  half: {
    alignItems: 'center',
    display: 'flex',
    flex: '0 0 400px',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    padding: `${theme.spacing(2)} ${theme.spacing(4)}`,
    textAlign: 'center',
    width: 400,

    '& h4': {
      alignItems: 'center',
      display: 'flex',
      fontSize: '1.4em',
      justifyContent: 'center',
      marginTop: 0,
      paddingTop: 0,

      '& svg': {
        marginRight: theme.spacing(2),
      }
    },
  },

  button: {
    alignItems: 'center',
    border: 'none',
    borderRadius: theme.spacing(0.5),
    color: theme.palette.background.paper,
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    margin: `${theme.spacing(1)} 0`,
    padding: `${theme.spacing(1)} ${theme.spacing(1)} ${theme.spacing(1)} ${theme.spacing(5)}`,
    position: 'relative',
    textTransform: 'none',
    width: '100%',

    '& p': {
      fontWeight: 700,
    },

    '& svg': {
      bottom: 0,
      left: theme.spacing(1),
      margin: 'auto 0',
      position: 'absolute',
      top: 0,
    }
  },

  'button-0': {
    backgroundColor: theme.palette.info.main,
  },

  'button-1': {
    backgroundColor: theme.palette.success.main,
  }
}))

const SplitSelection = ({sections}) => {
  const classes = useStyles();

  return (
    <>
      <div className={classes.container}>
        {sections.map(({title, icon, buttons}, sectionIndex) => (
          <div className={classes.half} key={sectionIndex}>
            <h4>{icon} {title}</h4>
            {buttons.map(({label, onClick}, buttonIndex) => (
              <button
                key={`${sectionIndex}-${buttonIndex}`}
                className={[classes.button, classes[`button-${buttonIndex}`]].join(' ')}
                onClick={onClick}
              ><Search/>&nbsp;<Typography variant="body1">{label}</Typography>
              </button>
            ))}
          </div>
        ))}
      </div>
    </>
  );
};

export default SplitSelection;
